const itemKey = '_whatsappRedirect';
const redirectStorage = {
  setUrl: (url: string) => localStorage.setItem(itemKey, url),
  getUrl: () => localStorage.getItem(itemKey),
  clear: () => localStorage.removeItem(itemKey),
};

export default redirectStorage;
